<template>
  <div class="app-basic-min-width default-layout app-flex-column">
    <MHeader></MHeader>
    <div class="main app-flex-column">
      <router-view></router-view>
    </div>
    <MFooter></MFooter>
  </div>
</template>

<script>
import MHeader from '@/components/common/header/MHeader'
import MFooter from '@/components/common/MFooter'

export default {
  components: {
    MHeader,
    MFooter
  }
}
</script>

<style lang="scss" scoped></style>
